import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

/* const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
]; */

function DropDown(props) {
  const { name, label, value, error = null, onChange, options, width, ...reset } = props;
  const classes = useStyles();
  /* const [values, setValues] = React.useState({
    age: ""
  }); */
  // debugger;
  console.log(options);

  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  /* function handleChange(event) {
    setValues(oldValues => ({
      ...oldValues,
      [event.target.name]: event.target.value
    }));
  } */

  return (
    <form className={classes.root} autoComplete="off">
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel
          shrink
          ref={inputLabel}
          htmlFor="outlined-age-always-notched"
        >
          {label}
        </InputLabel>
        <Select
          value={value}
          onChange={onChange}
          style={{ height: 34 }}
          input={
            <OutlinedInput
              notched
              labelWidth={labelWidth}
              name={name}
              id="outlined-age-always-notched"
            />
          }
        >
          {options.map((name) => (
            <MenuItem
              key={name.id}
              value={name.id}
            //style={getStyles(name, personName, theme)}
            >
              {name.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </form>
  );
}

export default DropDown;
